import { usePublishingContext } from "../../../contexts/PublishingContext.js";
import { echartsDarkTheme } from "../constants/echartsDarkTheme.js";
import React, { useEffect } from "react";
import { useAtalayaContext } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import * as echarts from "echarts/core";
import { DataZoomComponent, GridComponent, LegendComponent, TitleComponent, ToolboxComponent, TooltipComponent } from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { UniversalTransition } from "echarts/features";
//#region src/modules/Stats/shared/ReportTypesStackedBarChart.tsx
echarts.use([
	DataZoomComponent,
	TitleComponent,
	ToolboxComponent,
	TooltipComponent,
	GridComponent,
	LegendComponent,
	BarChart,
	CanvasRenderer,
	UniversalTransition
]);
echarts.registerTheme("THERMS Dark", echartsDarkTheme);
function ReportTypesStackedBarChart({ reportsHistogram }) {
	const { isDarkMode } = useAtalayaContext();
	const isPublishing = usePublishingContext()?.isPublishing;
	const containerRef = React.useRef(null);
	useEffect(() => {
		if (!containerRef.current || !reportsHistogram) return void 0;
		const chart = echarts.init(containerRef.current, isDarkMode ? "THERMS Dark" : "light");
		const reportTypes = /* @__PURE__ */ new Map();
		const dates = reportsHistogram.map((date, i) => {
			date.reportTypes.forEach((reportType) => {
				const reportTypeData = reportTypes.get(reportType.name) || {
					color: reportType.color,
					data: new Array(reportsHistogram.length).fill(0),
					name: reportType.name
				};
				reportTypeData.data[i] = reportType.count;
				reportTypes.set(reportType.name, reportTypeData);
			});
			return date.formattedDate;
		});
		const reportTypesSeriesData = Array.from(reportTypes.values()).map((reportType) => ({
			color: reportType.color,
			data: reportType.data,
			name: reportType.name,
			stack: "reportType",
			type: "bar"
		}));
		const option = {
			grid: { top: 110 },
			legend: {
				data: reportTypesSeriesData.map((reportType) => reportType.name),
				top: 50
			},
			series: reportTypesSeriesData,
			title: {
				left: "center",
				subtext: "Overall height of the bar represents day total",
				subtextStyle: { lineHeight: 4 },
				text: "Report Types Per Day"
			},
			xAxis: {
				data: dates,
				type: "category"
			},
			yAxis: { type: "value" }
		};
		if (!isPublishing) {
			option.tooltip = { trigger: "axis" };
			option.toolbox = { feature: {
				dataZoom: { yAxisIndex: "none" },
				restore: {},
				saveAsImage: {}
			} };
			option.dataZoom = [{
				end: 100,
				start: 0,
				type: "inside"
			}, {
				end: 100,
				start: 0
			}];
		}
		chart.setOption(option);
		return () => chart.dispose();
	}, [
		reportsHistogram,
		containerRef.current,
		isDarkMode
	]);
	return /* @__PURE__ */ jsx("div", {
		className: "h-full w-full",
		ref: containerRef,
		style: {
			height: 500,
			width: "100%"
		}
	});
}
//#endregion
export { ReportTypesStackedBarChart };

//# sourceMappingURL=ReportTypesStackedBarChart.js.map